<template>
  <BlankPage :status="pageStatus" />
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import mmsService from '@/services/mmsService';
import BlankPage from '@/components/BlankPage.vue';

export default {
  components: {
    BlankPage,
  },
  data() {
    return {
      pageStatus: 'blank',
      // 公司代碼
      companyId: '',
      // 活動明細代碼
      unionId: '',
      // 會員來源代碼
      memberSourceId: '',
      activityNow: true,
    };
  },
  created() {
    const vm = this;
    const { companyId, unionId } = vm.$route.query;

    this.set({ name: 'companyId', value: companyId });
    sessionStorage.setItem('companyId', companyId);

    mmsService.getQrCodeActivity({ companyId, unionId })
      .toPromise()
      .then((getQrCodeActivityRes) => {
        // 若查不到資料，導向錯誤頁
        if (getQrCodeActivityRes.response.status !== '200') {
          vm.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
        }
        const qrCodeActivity = getQrCodeActivityRes.response.data[0];
        vm.companyId = companyId;
        vm.unionId = unionId;
        vm.memberSourceId = qrCodeActivity.memberSourceId;

        // 新增掃碼紀錄
        mmsService.postQrCodeScanningLog({ unionId, type: 0 })
          .toPromise()
          .finally(() => {
            // 非活動期間跳轉
            this.set({ name: 'beforeWording', value: qrCodeActivity.message[0].object[0].property[0].propertyValue });
            this.set({ name: 'afterWording', value: qrCodeActivity.message[1].object[0].property[0].propertyValue });

            if (qrCodeActivity.startTime > Date.now()) {
              vm.$router.replace({ name: 'Error', params: { status: 'activityBefore' } });
            } else if (qrCodeActivity.endTime < Date.now()) {
              vm.$router.replace({ name: 'Error', params: { status: 'activityAfter' } });
            } else {
              // 依活動類型作不同處理
              switch (qrCodeActivity.typeNo) {
              // 站內 Event
                case 2:
                  vm.$router.replace({ name: 'McsQrcodeGetCoupon', query: vm.$route.query });
                  break;
                // 前往外部連結
                case 3:
                  // 判斷是否需要SSO驗證
                  if (qrCodeActivity.isMemberBinding) {
                    vm.goToSSO(qrCodeActivity.typeProcessNo);
                  } else {
                    window.location.replace(qrCodeActivity.directURL);
                  }
                  break;
                default:
                  vm.$router.replace({ name: 'Error', params: { status: 'unstableNetwork' } });
                  break;
              }
            }
          });
      })
      .catch(() => {
        vm.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
      });
  },
  computed: {
    ...mapState([
      'couponImage',
      'couponDesc',
      'couponLimitCnt',
      'limitDesc']),
  },
  methods: {
    ...mapActions('pmt', [
      'getPrizeCustomizeCoupon',
    ]),
    ...mapMutations(['set']),
    // 前往SSO
    goToSSO(no) {
      const vm = this;
      const href = window.location.href
        .split('?').shift()
        .split('#').shift()
        .replace(/\/$/, '')
        .replace(vm.$route.path, '');
      const redirectQueryString = new URLSearchParams({
        companyId: vm.companyId, unionId: vm.unionId, memberSourceId: vm.memberSourceId, isRedirect: no === 3,
      }).toString();
      const redirectUrl = encodeURIComponent(`${href}/qrCode/ssoCallback?${redirectQueryString}`);
      const ssoUrl = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_VUE_SSO_URL}' : process.env.VUE_APP_VUE_SSO_URL;
      const ssoLoginQueryString = new URLSearchParams({ companyid: vm.companyId, membersourceid: vm.memberSourceId }).toString();
      const ssoLoginUrl = `${ssoUrl}/login?${ssoLoginQueryString}&redirect_url=${redirectUrl}`;

      window.location.assign(ssoLoginUrl);
    },
  },
};
</script>
